import React from 'react';
import palette from '../../../themes/theme/pallete';
import { SvgIcon } from '../../common/SvgIcon';
import { simpleIconPropsTypes } from '../propTypes';

export const IconArrowInCircle = (props) => {
  const { className, width = 24, height = 24 } = props;

  return (
    <SvgIcon width={width} height={height} viewBox="0 0 26 26" className={className}>
      <g transform="translate(-675.000000, -367.000000) translate(251.000000, 334.000000) translate(425.000000, 34.000000)">
        <circle cx="12" cy="12" r="12.5" fill="#FFF" stroke="#000" strokeOpacity=".1" />
        <path fill={palette.gray.main} d="M8.59 16.59L13.17 12 8.59 7.41 10 6 16 12 10 18z" />
      </g>
    </SvgIcon>
  );
};

IconArrowInCircle.propTypes = simpleIconPropsTypes;
